<template>
  <div class="animation-container">
    <!-- <svgList /> -->
    <div class="animation-box">
      <div class="animation-item item-1">
        <svg class="iconpark-icon">
          <use href="#reduqushi"></use>
        </svg>
        <span>热度趋势</span>
      </div>
      <div class="animation-item item-2">
        <svg class="iconpark-icon">
          <use href="#toufangdarenfenxi"></use>
        </svg>
        <span>投放达人分析</span>
      </div>
      <div class="animation-item item-3">
        <svg class="iconpark-icon">
          <use href="#neirongguanjianci"></use>
        </svg>
        <span>内容关键词</span>
      </div>
      <div class="animation-item item-4">
        <svg class="iconpark-icon">
          <use href="#baowenfenxi"></use>
        </svg>
        <span>爆文分析</span>
      </div>
      <div class="animation-item item-5">
        <svg class="iconpark-icon">
          <use href="#jiagequjiantongji"></use>
        </svg>
        <span>价格区间统计</span>
      </div>
      <div class="animation-item item-6">
        <svg class="iconpark-icon">
          <use href="#xiaofeizhehuaxiang"></use>
        </svg>
        <span>消费者画像</span>
      </div>
      <div class="animation-item item-7">
        <svg class="iconpark-icon">
          <use href="#jiagepianhaofenxi"></use>
        </svg>
        <span>价格偏好分析</span>
      </div>
      <div class="animation-item item-8">
        <svg class="iconpark-icon">
          <use href="#xiaofeizhepingjia"></use>
        </svg>
        <span>消费者评价</span>
      </div>
    </div>
  </div>
</template>

<script>
// import svgList from "@/components/svgList";
export default {
  name: "animationContainer",
  // components: { svgList },
};
</script>

<style>
</style>